import {
    createBrowserServices,
    createServerServices,
    ICreateBrowserServicesParams,
    ICreateServerServicesParams,
} from "@tiendeo/cookies";
import type { Request, Response } from "express";
import { getStatsData } from "./tiendeoStats";
import type { IConfig } from "config/IConfig";
import type { ITexts } from "translations/ITexts";

const createCookiesServices = (
    configs: IConfig,
    texts: ITexts,
    req: Request,
    res: Response,
    searchWord?: string,
) => {
    const isServer = typeof window === "undefined";

    const {
        cookie_domain,
        default_search,
        default_city,
        internal_api_url,
        show_policy_cookies,
        version_files_js,
    } = configs;

    const params: ICreateServerServicesParams | ICreateBrowserServicesParams = {
        StatsData: getStatsData(default_city, searchWord || default_search) as any,
        Texts: {
            FUNCTIONAL_COOKIES_DESC: texts.FUNCTIONAL_COOKIES_DESC,
            MARKETING_COOKIES_DESC: texts.MARKETING_COOKIES_DESC,
            MARKETING_COOKIES_DESC_2: texts.MARKETING_COOKIES_DESC_2,
            NECESSARY_COOKIES_DESC: texts.NECESSARY_COOKIES_DESC,
            NECESSARY_COOKIES_DESC_BLOCK: texts.NECESSARY_COOKIES_DESC_BLOCK,
            STATS_COOKIES_DESC: texts.STATS_COOKIES_DESC,
        },
        cookie_domain,
        internal_api_url,
        req,
        res,
        search: default_search,
        show_policy_cookies,
        version_files_js,
    };

    return isServer
        ? createServerServices({ ...params, req, res: res as Response })
        : createBrowserServices(params);
};

export default createCookiesServices;
